import React from 'react'
import styles from './CheckBoxV2.module.css'

function CheckBoxV2({id, value, setValue, label }) {
    return (
        <div className={styles.container}>
            <div className={styles.round}>
                <input id={id} type="checkbox" checked={value} onChange={(e) => { setValue(e.target.checked) }} className='mr-[15px]'/>
                <label for={id}>{label}</label>
            </div>
        </div>
    )
}

export default CheckBoxV2